import React from 'react';

const Item = ({ description, icon, number, title, isLast }) => {
  return (
    <div className="htp-modal-step">
      <div className="htp-modal-step-rail">
        <div className="htp-modal-step-dot">
          <span>{number}</span>
        </div>
        {!isLast && <div className="htp-modal-step-line" />}
      </div>
      <div className="htp-modal-step-content">
        <div className="htp-modal-step-icon">
          {icon}
        </div>
        <div className="htp-modal-step-text">
          <h4 className="htp-modal-step-title">{title}</h4>
          <p className="htp-modal-step-desc">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default Item
